import React from "react";
import { InputGroup, FormControl, Alert } from "react-bootstrap";

import { Footer } from "../components/include/Footer";
import Title from "../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
} from "../redux/selectors/authSelector";
import { verifyEmail } from "../redux/actions/authActions";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "../redux/actions/toastActions";
import emailIcon from "../assets/Icons/email.svg";
import leftIcon from "../assets/Icons/leftArrow.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import Logo from "../assets/logo.jpg";
import "../styles/Login.scss";
import EmailVerification from "../components/common/EmailVerification";
import SuccessfullCard from "../components/common/SuccessfullCard";
import logoBg from "../assets/Icons/Frame 475.svg";
import loginBg from "../assets/pst-auth-bg.png";
import { useCountryNavigate } from "../components/common/UseCountryNavigate";

const SuccessMessage = () => {
  const [username, setusername] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : ""
  );
  const [password, setpassword] = useState(
    process.env.NODE_ENV !== "production" ? "123456" : ""
  );
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setremember] = useState(false);
  // const [IPAddress, setIPAddress] = useState('')
  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const Data = useSelector(isData);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const location = useLocation();

  const type = location.state?.type;
  console.log(type, "type");

  const onVerifyAction = async (event) => {
    navigate("reset-password");
    // event.preventDefault();
    // dispatch(
    //   verifyEmail({ username: username, password: password, remember: remember })
    // );
  };

  const onResendAction = async (event) => {
    event.preventDefault();
    // dispatch(
    //   verifyEmail({ username: username, password: password, remember: remember })
    // );
  };

  return (
    <>
      <Title name="Verification" />
      {console.log("errorMsg => cccccccccccc", errorMsg)}
      <div
        className={`account-pages `}
        style={{ paddingTop: "12%" }}
      >
        <div className="account-pages">
          {/* <img src={type === "signup" ? signupBg : loginBg} className="login-background-img" alt="background" /> */}
          <img src={loginBg} className="login-background-img" alt="background" />
        </div>
        <div className="absolute top-8 right-8 w-80 h-auto z-10">
          <img src={logoBg} alt="App Logo" className="w-full h-auto" />
        </div>

        <div className="container ">
          <div
            className={`row ${type === "signup"
              ? "justify-content-end"
              : "justify-content-start"
              }`}
          >
            <div className="col-md-8 col-lg-6 col-xl-5">
              {errorMsg && <Alert variant="info">{errorMsg}</Alert>}
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <SuccessfullCard
                  title={
                    type === "signup" ? "Email Verification" : "Reset Password"
                  }
                  btnName={
                    type === "signup"
                      ? "Explore Now"
                      : "Proceed to Log In"
                  }
                  subTitle={
                    type === "signup"
                      ? "Your Email id is verified successfully"
                      : "Your password is reset successfully"
                  }
                  type="signup"
                />
              </div>
              {/* <div className="mt-5 text-center">
                <Footer />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessMessage;
